// source: pbtypes/gen/scan_planner/trajectory_motion_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.scan_planner.TrajectoryMotionInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.TrajectoryMotionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.TrajectoryMotionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.TrajectoryMotionInfo.displayName = 'proto.scan_planner.TrajectoryMotionInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.TrajectoryMotionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.TrajectoryMotionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.TrajectoryMotionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
hasLargeHeadingChange: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
speed: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
distanceMargin: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
headingRateLimit: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
gimbalPitchRateLimit: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
maxPathSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.TrajectoryMotionInfo}
 */
proto.scan_planner.TrajectoryMotionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.TrajectoryMotionInfo;
  return proto.scan_planner.TrajectoryMotionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.TrajectoryMotionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.TrajectoryMotionInfo}
 */
proto.scan_planner.TrajectoryMotionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasLargeHeadingChange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSpeed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDistanceMargin(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeadingRateLimit(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitchRateLimit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxPathSpeed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.TrajectoryMotionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.TrajectoryMotionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.TrajectoryMotionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasLargeHeadingChange();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getDistanceMargin();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getHeadingRateLimit();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getGimbalPitchRateLimit();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getMaxPathSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * optional bool has_large_heading_change = 1;
 * @return {boolean}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.getHasLargeHeadingChange = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.TrajectoryMotionInfo} returns this
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.setHasLargeHeadingChange = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional float speed = 2;
 * @return {number}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.getSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.TrajectoryMotionInfo} returns this
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.setSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float distance_margin = 3;
 * @return {number}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.getDistanceMargin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.TrajectoryMotionInfo} returns this
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.setDistanceMargin = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float heading_rate_limit = 4;
 * @return {number}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.getHeadingRateLimit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.TrajectoryMotionInfo} returns this
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.setHeadingRateLimit = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float gimbal_pitch_rate_limit = 5;
 * @return {number}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.getGimbalPitchRateLimit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.TrajectoryMotionInfo} returns this
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.setGimbalPitchRateLimit = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float max_path_speed = 6;
 * @return {number}
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.getMaxPathSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.TrajectoryMotionInfo} returns this
 */
proto.scan_planner.TrajectoryMotionInfo.prototype.setMaxPathSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


goog.object.extend(exports, proto.scan_planner);
